<template>
  <div
    class="card"
    :class="{ active: isActive }"
    @mouseover="isActive = true"
    @mouseout="isActive = false"
  >
    <div class="card-contents-button-wrapper">
      <div class="flex-justifystart-aligncenter">
        <div class="category-name">
          {{ reportInfo.masterReport.rptPubYear }}년
          <!-- {{ reportInfo.masterReport.rptPubType }} -->
        </div>
        <div class="category-sub-name">
          {{ this.reportInfo.masterReport.anlMstNm }}
        </div>
      </div>
      <div class="card-contents">
        <div class="card-contents-box">
          <h3 class="card-title">{{ mainTitle }}</h3>
          <div class="category">
            <span>{{ navigationTitle }}</span>
          </div>
          <p>{{ reportInfo.summaryDesc }}</p>
          <div class="research-wrapper-box flex">
            <!-- <div class="research-wrapper flex">
              <div class="researcher">
                <span class="txt01">연구책임자</span>
                <span>|</span>
                <span class="txt02">{{
                  reportInfo.masterReport.rptAuthNm
                }}</span>
                <span></span>
              </div>
            </div> -->
            <div class="research-wrapper" :hidden="true">
              <div class="researcher">
                <span class="txt01">공동연구</span>
                <span>|</span>
                <span>김향자</span>
                <span class="txt02"
                  >(서울 시립대학교 도시사회학과 초빙교수)</span
                >
              </div>
            </div>
          </div>
          <div class="hashtag-wrapper">
            <button
              type="button"
              class="btn hashtag"
              v-for="item in reportInfo.classifications"
              :key="item.anlClsNo"
            >
              #{{ item.anlClsNm }}
            </button>
          </div>
        </div>
        <div class="card-area">
          <img
            :src="imageData"
            style="height: calc(181px); display: block; border: 1px solid #ccc"
          />
          <button type="button" class="btn" @click="this.goSearchDetail">
            전체보기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadImage } from "@/api/StatReportSearch.js";
export default {
  name: "SearchCardItem",
  props: {
    anlDetailNo: {
      type: Number,
      default: 0,
    },
    reportInfo: {
      type: Object,
    },
    searchPageIndex: {
      type: Number,
      default: 1,
    },
    searchModel: {
      type: Object,
      deep: true,
    },
  },
  computed: {
    mainTitle: function () {
      let title = "";
      switch (this.reportInfo.rstContentsType) {
        case "I":
          title = this.reportInfo.indexNm;
          break;
        case "S":
          title = this.reportInfo.sessionNm;
          break;
        case "C":
          title = this.reportInfo.chapterNm;
          break;
      }
      return title;
    },
    navigationTitle: function () {
      let title = "";
      switch (this.reportInfo.rstContentsType) {
        case "I":
          title =
            this.reportInfo.masterReport.anlMstNm +
            " > " +
            this.reportInfo.chapterNm +
            " > " +
            this.reportInfo.sessionNm +
            " > " +
            this.reportInfo.indexNm;
          break;
        case "S":
          title =
            this.reportInfo.masterReport.anlMstNm +
            " > " +
            this.reportInfo.chapterNm +
            " > " +
            this.reportInfo.sessionNm;
          break;
        case "C":
          title =
            this.reportInfo.masterReport.anlMstNm +
            " > " +
            this.reportInfo.chapterNm;
          break;
      }
      return title;
    },
  },
  data() {
    return {
      isActive: false,
      imageData: "",
    };
  },
  created() {
    this.imageFileLoad();
  },
  mounted() {},
  methods: {
    goSearchDetail() {
      this.$router.push({
        name: "통계 보고서 상세",
        params: {
          anlDetailNo: this.anlDetailNo,
          searchModel: this.searchModel,
        },
      });
    },
    imageFileLoad() {
      if (this.reportInfo.masterReport.anlImgFileId) {
        loadImage(this.reportInfo.masterReport.anlImgFileId).then(
          (response) => {
            if (response) {
              const url = window.URL.createObjectURL(response);
              this.imageData = url;
            }
          }
        );
      }
    },
  },
};
</script>

<style scoped>
.card:hover {
  border-radius: 15px;
  outline: 3px solid #b4a0d4;
  background: #fff;
}

.card-area {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.card-area .btn {
  border-radius: 5px;
  background: #666;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9.68px 42px;
}
.flex-justifystart-aligncenter {
  display: flex;
  align-items: center;
  gap: 14px;
}

.category-name {
  border-radius: 30px;
  border: 1px solid #524f74;
  background: #fff;
  display: flex;
  padding: 5px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.category-sub-name {
  color: #666;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card {
  width: 100%;
  min-height: 276px;
  border-radius: 15px;
  box-shadow: 3px 5px 15px #e7e0e0;
  position: relative;
  padding: 23px 15px;
  background-color: #fff;
}

.card-title {
  color: #524f74;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  @media screen and (max-width: 768px) {
    font-size: clamp(18px, 16px + 0.625vw, 24px);
  }
}

.card .category span {
  color: #333;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.card-contents {
  width: calc(100%);
  min-height: 190px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}
.card-contents > button {
  align-self: flex-end;
}
.card-contents-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 147px);
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    gap: 5px;
  }
}

.card-contents p {
  color: #666;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.researcher span {
  color: #666;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media screen and (max-width: 768px) {
    font-size: clamp(12px, 10px + 0.625vw, 18px) !important;
  }
}

.researcher span:nth-child(2) {
  margin: 0 5px;
  display: inline-block;
}

.researcher .txt02 {
  color: #ccc;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.research-wrapper {
  flex-wrap: wrap;
  align-items: center;
}
.hashtag-wrapper {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  padding: 10px 0;
  @media screen and (max-width: 768px) {
    align-items: flex-end;
    flex: 1;
  }
}

.hashtag-wrapper button {
  display: flex;
  padding: 5px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  border: 1px solid #666;
  background: #fff;
  color: #666;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.card-type2 .category::before {
  content: "";
  background-image: url("../../assets/img/research-before.png");
  display: inline-block;
  width: 5px;
  height: 15px;
  transform: translateY(2px);
  margin-right: 9px;
}
.card-type2 .card-contents {
  width: 100%;
  min-height: 150px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #cccccc;
}
.card-type2 .button-wrapper {
  gap: 5px;
  min-width: 169px;
}

.research-wrapper::before {
  content: "";
  background-color: #ccc;
  width: 5px;
  height: 15px;
  display: inline-block;
  margin-right: 6px;
}
.card-type2 .flex-column {
  display: flex;
  flex-direction: column;
  align-self: baseline;
}
.card-type2 .research-wrapper-box .research-wrapper {
  gap: 13px;
}
</style>
